import { render, staticRenderFns } from "./ModalDialog.vue?vue&type=template&id=3ffd8c6a&"
import script from "./ModalDialog.vue?vue&type=script&lang=js&"
export * from "./ModalDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports